import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerConfig } from '../data/siteConfig';
import { PriceCard } from './Shared';
const CHIPS = ['5 módulos + Módulo VIP + 3 bonos', '+240 páginas listas para usar', 'Llega a tu mail en minutos', `Garantía ${offerConfig.guaranteeDays} días`];
export const FinalCtaSection = () => {
  return <section className="bg-familia-dark border-t border-familia-darkBorder py-12 md:py-16 px-4 md:px-6" data-id="element-74" data-mp="3vs46a91z3pf9">
      <div className="max-w-7xl mx-auto text-center w-full" data-id="element-75" data-mp="2y6oxa9z9nut6">
        <h2 className="text-[26px] sm:text-3xl md:text-5xl font-display font-bold text-white mb-5 md:mb-6 leading-tight max-w-4xl mx-auto" data-id="element-76" data-mp="3335ml7i7cf7u">
          La semana que viene va a llegar igual.{' '}
          <span className="text-familia-accent" data-id="element-77" data-mp="3cu06i57z72q4">
            La pregunta es si llega con un plan o improvisando otra vez.
          </span>
        </h2>
        <p className="text-body text-familia-onDarkMuted max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-78" data-mp="2fc9v6bhnrm14">
          Pagando una sola vez, te llevás 240 páginas listas para usar, que te
          llegan al mail en minutos y tienen {offerConfig.guaranteeDays} días
          de garantía.{' '}
          <span className="text-white font-semibold" data-id="element-79" data-mp="28dfdgxockzel">
            Hoy a la tarde ya pueden estar haciendo la primera actividad
            juntos.
          </span>
        </p>
        <div className="mb-10 md:mb-14 flex justify-center" data-id="element-80" data-mp="1ynvp5chv8dcc">
          <PriceCard data-id="element-81" data-mp="1ulimwy2buxkb" />
        </div>
        <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto mb-10 md:mb-12" data-id="element-82" data-mp="1ulscikjgn2ph">
          {CHIPS.map(item => <li key={item} className="bg-familia-darkCard border border-familia-darkBorder p-4 rounded-xl flex items-center justify-center gap-2" data-id="element-83" data-mp="1poih8o9e3wtq">
              <CheckIcon className="w-5 h-5 text-familia-checkDark shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-84" data-mp="1forp2t8axtwt" />
              <span className="text-[15px] font-semibold text-white" data-id="element-85" data-mp="3f0awh3dyiu4d">
                {item}
              </span>
            </li>)}
        </ul>
        <p className="text-body text-familia-onDarkMuted max-w-2xl mx-auto" data-id="element-86" data-mp="3a06aixua576r">
          <span className="font-bold text-familia-gold" data-id="element-87" data-mp="18biog4jm6dvu">P.D.:</span> Si lo
          imprimís y no te sirve, te devolvemos la plata. Lo único que perdés es
          no probarlo.
        </p>
      </div>
    </section>;
};